let cart = {};

// check for protection (we default to FALSE)
if (localStorage.protection == null) {
    //localStorage.protection = "true"
} else {
    localStorage.removeItem("protection");
}

// open cart
async function openCart() {
    // update active body
    await updateCart();

    document.querySelector("#cart").classList.add("active");
    document.querySelector("body").classList.add("noScroll");
}

// close cart
function closeCart() {
    document.querySelector("#cart").classList.remove("active");
    document.querySelector("body").classList.remove("noScroll");
}

// open cart event listener
document.querySelectorAll(`.openCart`).forEach(function (element) {
    element.addEventListener("click", openCart);
});

//close cart event listener
document.querySelectorAll(".closeCart").forEach(function (element) {
    element.addEventListener("click", closeCart);
});

// checkout button loading
document.querySelector("#cartFooterCheckout").addEventListener("click", async function () {
    this.classList.add("loading");

    // add melting chocloate if true
    if (localStorage.protection === "true") {
        await addProduct({
            id: Shopify.country === "US" ? 42628047306928 : 42744682184880,
            quantity: 1
        });
    }

    window.location.href = "/checkout";

    setTimeout(() => {
        this.classList.remove("loading");
    }, 500);
});

// update whether the body or empty is shown
async function updateCart(skipFetch = false) {
    // fetch cart
    if (skipFetch === false) {
        cart = await fetch("/cart.js")
            .then(function (data) {
                return data.json();
            });
    }

    // check if cart is empty
    if (cart.item_count === 0) {
        document.querySelector("#cartBody").classList.remove("active");
        document.querySelector("#cartEmpty").classList.add("active");
        document.querySelector("#cartFooter").classList.remove("active");
    } else {
        document.querySelector("#cartBody").classList.add("active");
        document.querySelector("#cartEmpty").classList.remove("active");
        document.querySelector("#cartFooter").classList.add("active");

        // reset container
        document.querySelector("#cartBody").innerHTML = "";

        // remove melting protection if added
        const protectionProduct = cart.items.filter(item => item.handle === "melting-protection" || item.handle === "melting-protection-international");
        if (protectionProduct.length > 0) {
            cart = await changeProduct({
                id: protectionProduct[0].key,
                quantity: 0
            });
            await updateCart(true);
            return;
        }

        // append items to body
        cart.items.forEach(function (item) {
            // subtitle HTML
            function subtitleHTML() {
                if (item.handle === "sex-chocolate" || item.handle === "sex-chocolate-international") {
                    let HTML = `${item.quantity} ${item.quantity === 1 ? "Box" : "Boxes"}`;
                    if (item.selling_plan_allocation != null) {
                        HTML += `<br><span>Delivery every ${item.selling_plan_allocation.selling_plan.name}</span>`;
                    }
                    return HTML;
                }
                return item.variant_title ?? "";
            }

            // price html
            function priceHTML() {
                if (item.original_line_price > item.final_line_price) {
                    return `
                    <s>${price(item.original_line_price)}</s>
                    <span>${price(item.final_line_price)}</span>
                `;
                } else if (item.handle === "your-guide-to-mind-blowing-female-orgasms-sex-life") {
                    return `
                    <s>${price(1499 * item.quantity)}</s>
                    <span>${price(item.final_line_price)}</span>
                `;
                }
                return `<span>${price(item.final_line_price)}</span>`;
            }

            // insert HTML
            document.querySelector("#cartBody").insertAdjacentHTML("beforeend", `
            <div class="cartBodyItem" key="${item.key}">
                <img class="cartBodyItemImage" src="${item.image ? item.image : `https://cdn.shopify.com/s/files/1/0573/3695/5056/files/sweet-sexyPic1.png?v=1649339700`}&width=200" width="76" height="76">
                <div>
                    <div class="cartBodyItemTitle">${item.product_title}</div>
                    <div class="cartBodyItemSubtitle">${subtitleHTML()}</div>
                    <div class="cartBodyItemLabel">Quantity:</div>
                    <div class="cartBodyItemQuantity">
                        <div class="cartBodyItemQuantityMinus">
                            <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="4.25 4.25 33.5 33.5"><path d="M21 36.75C29.6985 36.75 36.75 29.6985 36.75 21C36.75 12.3015 29.6985 5.25 21 5.25C12.3015 5.25 5.25 12.3015 5.25 21C5.25 29.6985 12.3015 36.75 21 36.75Z" stroke="#120A0A" stroke-width="2" stroke-miterlimit="10"></path><path d="M14.4375 21H27.5625" stroke="#120A0A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                        </div>
                        <div class="cartBodyItemQuantityCount">${item.quantity}</div>
                        <div class="cartBodyItemQuantityPlus">
                            <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="4.25 4.25 33.5 33.5"><path d="M21 36.75C29.6985 36.75 36.75 29.6985 36.75 21C36.75 12.3015 29.6985 5.25 21 5.25C12.3015 5.25 5.25 12.3015 5.25 21C5.25 29.6985 12.3015 36.75 21 36.75Z" stroke="#120A0A" stroke-width="2" stroke-miterlimit="10"></path><path d="M14.4375 21H27.5625" stroke="#120A0A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path><path d="M21 14.4375V27.5625" stroke="#120A0A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                        </div>
                    </div>
                </div>
                <div>
                    <div class="cartBodyItemRemove">
                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="16" cy="16" r="15.25" stroke="#999999" stroke-width="1.5"/>
                            <path d="M22.875 10.375H9.125" stroke="#999999" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M14.125 14.125V19.125" stroke="#999999" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M17.875 14.125V19.125" stroke="#999999" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M21.625 10.375V22.25C21.625 22.4158 21.5592 22.5747 21.4419 22.6919C21.3247 22.8092 21.1658 22.875 21 22.875H11C10.8342 22.875 10.6753 22.8092 10.5581 22.6919C10.4408 22.5747 10.375 22.4158 10.375 22.25V10.375" stroke="#999999" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M19.125 10.375V9.125C19.125 8.79348 18.9933 8.47554 18.7589 8.24112C18.5245 8.0067 18.2065 7.875 17.875 7.875H14.125C13.7935 7.875 13.4755 8.0067 13.2411 8.24112C13.0067 8.47554 12.875 8.79348 12.875 9.125V10.375" stroke="#999999" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>
                    <div class="cartBodyItemPrice">${priceHTML()}</div>
                </div>
            </div>
        `);

            // minus
            document.querySelector(`.cartBodyItem[key="${item.key}"] .cartBodyItemQuantityMinus`).addEventListener("click", function () {
                if (item.quantity === 1) {
                    document.querySelector(`.cartBodyItem[key="${item.key}"] .cartBodyItemRemove`).click();
                } else {
                    item.quantity--;
                    updateCartItem(this);
                }
            });

            // plus
            document.querySelector(`.cartBodyItem[key="${item.key}"] .cartBodyItemQuantityPlus`).addEventListener("click", function () {
                item.quantity++;
                updateCartItem(this);
            });

            // remove
            document.querySelector(`.cartBodyItem[key="${item.key}"] .cartBodyItemRemove`).addEventListener("click", function () {
                item.quantity = 0;
                updateCartItem(this);
                this.closest(".cartBodyItem").remove();
            });

            // update line item function
            async function updateCartItem(element) {
                // find input
                let countElement = element.closest(".cartBodyItem").querySelector(".cartBodyItemQuantityCount");

                // update label
                countElement.textContent = item.quantity;

                // update cart in shopify
                cart = await changeProduct({
                    id: item.key,
                    quantity: item.quantity
                });

                // update active body
                await updateCart(true);
            }
        });

        /***************** Melting Protection ***************/

        // insert melting protection to cart body
        document.querySelector("#cartBody").insertAdjacentHTML("beforeend", `
            <div id="cartBodyUpgrade">
                <label id="cartBodyUpgradeButton">
                     <div class="switch">
                        <input id="cartBodyUpgradeInput" type="checkbox" class="switchInput" ${localStorage.protection === "true" ? "checked" : ""}>
                        <div class="switchSlider">
                            <svg width="13" height="10" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M11.5 1.5L4.5 8.5L1 5" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>
                    </div>
                    <div id="cartBodyUpgradeButtonLabel">Melting <br> Protection</div>
                    <div id="cartBodyUpgradeButtonPrice">+$4.99</div>
                    <img id="cartBodyUpgradeButtonIcon" src="https://cdn.shopify.com/s/files/1/0573/3695/5056/files/cart-summer-proofed.svg?v=1680940380" alt="summer proof">
                </label>
                <img id="cartBodyUpgradeBanner" src="https://cdn.shopify.com/s/files/1/0573/3695/5056/files/cart-melting.svg?v=1680940223" alt="melting protection benefits">
            </div>
        `);

        // setup event listener for melting toggle
        document.querySelector("#cartBodyUpgradeInput").addEventListener("change", async function () {
            // determine if we add or remove the protection
            if (this.checked) {
                localStorage.protection = "true";
            } else {
                localStorage.protection = "false";
            }
            await updateCart();
        });

        /**************************** End of Melting Protection *********/

        // update footer
        document.querySelector("#cartFooterSubtotalCount").textContent = `${cart.item_count} ${cart.item_count == 1 ? "item" : "items"}`;
        if (localStorage.protection === "true") {
            let protectionPriceNum = 499;
            document.querySelector("#cartFooterSubtotalValue").textContent = price(cart.items_subtotal_price + protectionPriceNum);
        } else {
            document.querySelector("#cartFooterSubtotalValue").textContent = price(cart.items_subtotal_price);
        }
    }
}